import './components/static/css/style.css';
import './components/static/css/fancybox.css';
// import './components/static/css/slick-theme1.8.1.css'
import './components/static/css/slick1.8.1.css'

import { Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer'
import HomePage from './components/HomePage'
import ServicesPage from './components/ServicesPage';
import Service1Page from './components/Service1Page';
import Service2Page from './components/Service2Page';
import Service3Page from './components/Service3Page';
import Service4Page from './components/Service4Page';
import Service5Page from './components/Service5Page';
import Service6Page from './components/Service6Page';
import AboutCompanyPage from './components/AboutCompanyPage';
import NewsArticlesPage from './components/NewsArticlesPage';
import SingleNewsPage from './components/SingleNewsPage';
import ContactsPage from './components/ContactsPage';
import GalleryPage from './components/GalleryPage';
import GalleryAllPage from './components/GalleryAllPage';
import  { routes, RoutesProvider } from './contexts/RoutesContext';
import NotFoundPage from './components/NotFoundPage';

function App() {    //I had to use Fragment instead of <></> empty tags because they were throwing an error

    
  return ( 
    
      <RoutesProvider>   

        <Header />

        <Routes> 
            <Route element={<HomePage />} path="/" exact />
            <Route element={<ServicesPage />} path={routes.services.path} exact />
            <Route element={<Service1Page />} path={routes.service_1.path} exact />
            <Route element={<Service2Page />} path={routes.service_2.path} exact />
            <Route element={<Service3Page />} path={routes.service_3.path} exact />
            <Route element={<Service4Page />} path={routes.service_4.path} exact />
            <Route element={<Service5Page />} path={routes.service_5.path} exact />
            <Route element={<Service6Page />} path={routes.service_6.path} exact />
            <Route element={<AboutCompanyPage />} path={routes.about_company.path} exact />
            <Route element={<NewsArticlesPage />} path={routes.news_articles.path} exact />
            <Route element={<SingleNewsPage />} path={routes.single_news.path} exact />
            <Route element={<GalleryPage />} path={routes.gallery.path} exact />
            <Route element={<GalleryAllPage />} path={routes.gallery_all.path} exact />
            <Route element={<ContactsPage />} path={routes.contacts.path} exact /> 
            <Route element={<NotFoundPage />} path='*' />
        </Routes>

        <Footer />

      </RoutesProvider>

  );
}
 
export default App;
